import Settings from '../settings';

export const MAINTENANCE_EVENT = 'system-maintenance';

export const notifyMaintenanceMode = () => {
  if (typeof window !== 'undefined' && window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent(MAINTENANCE_EVENT));
  }
};

export const isMaintenanceResponseBody = body =>
  body && body.codigo === '503' && body.mensaje === 'Sistema en mantenimiento';

export const handleMaintenanceResponse = response => {
  if (!response || response.status !== 503 || !response.clone) {
    return;
  }

  response
    .clone()
    .json()
    .then(body => {
      if (isMaintenanceResponseBody(body)) {
        notifyMaintenanceMode();
      }
    })
    .catch(() => {});
};

export const installMaintenanceFetchHandler = () => {
  if (
    typeof window === 'undefined' ||
    !window.fetch ||
    window.fetch.__maintenanceHandlerInstalled
  ) {
    return;
  }

  const originalFetch = window.fetch.bind(window);
  const fetchWithMaintenanceHandler = (...args) =>
    originalFetch(...args).then(response => {
      handleMaintenanceResponse(response);
      return response;
    });

  fetchWithMaintenanceHandler.__maintenanceHandlerInstalled = true;
  window.fetch = fetchWithMaintenanceHandler;
};

export const getSystemStatus = () =>
  fetch(`${Settings.apiUrl}system-status`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
    .then(response => {
      if (response.status === 503) {
        return true;
      }

      if (!response.ok) {
        return false;
      }

      return response.json().then(data => data && data.mantenimiento === true);
    })
    .catch(() => false);
